module.exports = __webpack_public_path__ + "static/hp-leo-tucker.c14f2ab1.webp";